export enum ErrorCodeEnum {
  UNIQUE_GROUP_NAME = "UNIQUE_GROUP_NAME",
  UNIQUE_ROLE_NAME = "UNIQUE_ROLE_NAME",
  NOT_SPECIAL_ROLE_NAME = "NOT_SPECIAL_ROLE_NAME",
}